import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BarGraph from "@components/graphStatistics/Bar/Graphs";
import { useDispatch } from "react-redux";
import { salaryStatisticsActions } from "@store/actions";
import { DropdownDevise } from "@components/tailwindComponents";
import { useForm } from "react-hook-form";
import { parseValidNumber } from "@helpers/_functions";
const graphOptions = {
  tooltips: {
    bodyFontSize: 15,
    caretSize: 8,
    titleFontSize: 13
  },
  legend: {
    display: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          min: 0,
          precision: 0
        }
      }
    ],
    xAxes: [
      {
        maxBarThickness: 50
      }
    ]
  }
};


function SalaryGraph(props) {
  const { t: statTranslator } = useTranslation("pages.employés.statistics");
  const reduxDispatch = useDispatch();
  const { control,
    watch } = useForm({
      reValidateMode: "onChange",
      mode: 'onChange'
    })
  const salary = watch("salary")
  const [graphData, setGraphData] = useState({});
  const details = props.salaryStatistics?.details

  useEffect(() => {
    if (salary?._id) {
      const devise = salary?._id
      reduxDispatch(salaryStatisticsActions.filterData({ devise }));
      props.setSelectedDevise(devise);
    }
  }, [salary]);


  useEffect(() => {
    const salaries = props.salaryStatistics?.list || [];
    // const salaryAverage = details?.avgSalary;
    // const averageList = salaryAverage
    //   ? Array(salaries.length).fill(salaryAverage?.toFixed(2))
    //   : [];

    const dataSalary = {
      labels: salaries.map((x) => x.fullname),
      datasets: [
        {
          label: statTranslator("Salaire annuel"),
          backgroundColor: "#FFE7AB",
          borderColor: "#E0CFA6",
          borderWidth: 0.5,
          data: salaries.map((x) => (+x?.salary)?.toFixed?.(2) || 0)
        },
        // {
        //   label: statTranslator("Moyenne"),
        //   backgroundColor: "transparent",
        //   pointBackgroundColor: "#FFE7AB",
        //   pointBorderWidth: 2,
        //   borderColor: "#E0CFA6",
        //   data: averageList,
        //   type: "line"
        // }
      ]
    };
    setGraphData(dataSalary);
  }, [props.salaryStatistics]);

  return (
    <BarGraph
      legends={
        <div className="arh-flex arh-flex-col arh-space-y-3">
          <div className="arh-w-28">
            <DropdownDevise
              control={control}
              name="salary"
              customButtonClass="arh-py-3"
            />
          </div>
          <div className="arh-flex arh-space-x-3 arh-items-center">
            <span className="arh-w-3 arh-h-3 arh-bg-[#ffe7ab] "></span>
            <span className="arh-font-poppins arh-text-xs arh-text-darkColor arh-font-medium">
              {statTranslator("Salaire annuel")}
            </span>
          </div>
        </div>
      }
      graphData={graphData}
      title={statTranslator("Salaire")}
      graphOptions={graphOptions}
      target="salary"
      description={
        <>
          <div className="arh-text-base arh-font-medium">{statTranslator("Chiffres en détail")}</div>
          <div className="arh-flex arh-flex-col arh-space-y-2 ">
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Salaire le plus bas")}:</span> <span className="arh-text-[#859298]">{`${parseValidNumber(details?.minSalary) || 0} ${salary?._id || "USD"}`}</span></div>
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Salaire moyen")}:</span> <span className="arh-text-[#859298]">{`${parseValidNumber(details?.avgSalary) || 0} ${salary?._id || "USD"}`}</span></div>
            <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Salaire le plus élevé")}:</span> <span className="arh-text-[#859298]">{`${parseValidNumber(details?.maxSalary) || 0} ${salary?._id || "USD"}`}</span></div>
          </div>
        </>
      }
    />

  );
}

export default SalaryGraph;
